import React, { useId, useMemo } from 'react';

import MetricPopupConstants from './constants';

interface MetricPopupPortalIdsContextType {
  previewDivId: string;
  primaryActionDivId: string;
  coreToggleDivId: string;
}

export const MetricPopupPortalIdsContext =
  React.createContext<MetricPopupPortalIdsContextType>({
    previewDivId: MetricPopupConstants.PREVIEW_DIV_ID,
    primaryActionDivId: MetricPopupConstants.PRIMARY_ACTION_DIV_ID,
    coreToggleDivId: MetricPopupConstants.CORE_TOGGLE_DIV_ID,
  });

// Each metric popup gets its own portal targets. Popups can stack (e.g. an
// input metric opened from a compound metric), and shared ids would make the
// inner popup's preview and actions portal into the popup underneath it.
const MetricPopupPortalIdsProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const popupId = useId();
  const value = useMemo(
    () => ({
      previewDivId: `${MetricPopupConstants.PREVIEW_DIV_ID}-${popupId}`,
      primaryActionDivId: `${MetricPopupConstants.PRIMARY_ACTION_DIV_ID}-${popupId}`,
      coreToggleDivId: `${MetricPopupConstants.CORE_TOGGLE_DIV_ID}-${popupId}`,
    }),
    [popupId],
  );

  return (
    <MetricPopupPortalIdsContext.Provider value={value}>
      {children}
    </MetricPopupPortalIdsContext.Provider>
  );
};

export default MetricPopupPortalIdsProvider;
